var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('table-sortable',{staticClass:"table",attrs:{"rows":_vm.rows,"columns":_vm.columns},on:{"sort":function (ColumnsSort) { return _vm.columns = ColumnsSort; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }